import { cn } from "@/libs/cn";
import { Button } from "antd";
import { AiFillEdit } from "react-icons/ai";
import { PostImage } from ".";

export function AddedImages({
    images,
    onEdit,
    Component
}: {
    images: PostImage[];
    onEdit: () => void;
    Component?: React.ReactElement;
}) {

    const totalImages = images.length ?? 0;

    return (
        <>
            <div
                className="relative"
            >
                <div
                    className={cn("grid grid-cols-3 gap-2", {
                        "grid-cols-2": totalImages === 2,
                        "grid-cols-1": totalImages === 1
                    })}
                >
                    {
                        images.slice(0, 3).map((it, index) => (
                            <div
                                key={JSON.stringify(it)}
                                className={cn("relative rounded-md overflow-hidden aspect-square bg-black/40 flex items-center justify-center", {
                                    "aspect-auto": totalImages === 1,
                                })}
                            >
                                <img
                                    src={it.imgUrl as string}
                                    alt="Post image"
                                    className=" h-full !object-cover"
                                />
                                {
                                    totalImages > 3 && index === 2 && (
                                        <div
                                            className="absolute top-0 left-0 w-full h-full bg-black/50 flex items-center justify-center text-white text-lg font-poppins"
                                        >
                                            +{totalImages - 3} more
                                        </div>
                                    )
                                }
                            </div>
                        ))
                    }
                </div>
                <div
                    className="absolute top-2 left-2 flex items-center gap-2 "
                >
                    <Button
                        onClick={onEdit}
                        className="bg-white opacity-80 hover:opacity-100 !border-none !rounded-md !font-poppins"
                        icon={
                            <AiFillEdit />
                        }
                    >
                        Edit {totalImages > 1 ? "All" : ""}
                    </Button>
                    {
                        Component && (
                            Component
                        )
                    }
                </div>
            </div>

        </>
    )
}
